<!-- 
左边板块 
-->

<template>
  <div class="left_section">
    <BottomBack :borderStyle="{transform: 'scaleX(-1)',right: 0}">
      <div class="main">
        <SendOutWater/>
        <Inlet/>
        <OutWaterMonitor/>
        <!-- <WaterStat/> -->
        <!-- <WaterChart/> -->
        <!-- <WaterQuality/> -->
      </div>
    </BottomBack>
  </div>
</template>

<script>
import BottomBack from '..//BottomBack'
// 水量统计、水量统计图、水质检测组件
// import WaterStat from './components/WaterStat'
// import WaterChart from './components/WaterChart'
// import WaterQuality from './components/WaterQuality'
// 出水水质分析  进水水质分析  出水水质监测
import SendOutWater from './components/SendOutWater.vue';
import Inlet from './components/Inlet.vue';
import OutWaterMonitor from './components/OutWaterMonitor';
export default{
  name:'leftSection',
  components:{
    BottomBack,
    // WaterStat,
    // WaterChart,
    // WaterQuality,

    SendOutWater,
    Inlet,
    OutWaterMonitor
  },
  data(){
    return{

    }
  },
}
</script>

<style lang="less" scoped>
.left_section{
  position:fixed;
  top:325vh * @vh;
  .main{
    position: absolute;
    right: 15px;
    top: 117vh * @vh;
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
  .left_section{
    .main{
      top: 0;
      left: 60px;
    }
  }
}
</style>